import React, { useEffect, useMemo, useRef, useState } from "react";
import Highcharts, { numberFormat } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Drilldown from "highcharts/modules/drilldown";
import useApi from "./useApi";
import Loader from "src/components/loader.component";
import { Alert } from "react-bootstrap";
import NoData from "src/components/shared/noDataComponent";

const stateKeys = {
  chart: "chart",
};
if (typeof Highcharts === "object") {
  Drilldown(Highcharts);
}
function PieOrDonutChart({
  fetchOptions,
  fetchMethod,
  chartOptions,
  shouldFetch,
  chartProperties,
  events,
  isDonut,
  donutInnerSize,
  seriesData,
  otherOptions,
  totalValue,
  hasFetchParams,
  fetchParams,
  seriesKey = "series",
  shouldClear
}) {
  const { awaitingResponse, data, error, handleApi } = useApi();
  const [options, setOptions] = useState(null)
  const { chart: chartState } = useMemo(() => {
    return stateKeys;
  }, []);
  const chartRef = useRef(null);
  useEffect(() => {
    shouldFetch && handleApi(fetchMethod, fetchOptions, stateKeys["chart"], hasFetchParams,fetchParams,shouldClear);
  }, [shouldFetch,hasFetchParams,fetchParams,shouldClear]);
  useEffect(() => {
    !shouldFetch && setOptions(chartOptions)
  }, [shouldFetch, chartOptions])
  const propertiesForChart = chartProperties
    ? {
      ...chartProperties,
    }
    : {};
  const setInnerSize = (seriesToDrill) => {
    seriesToDrill.innerSize = isDonut ? donutInnerSize : 0;
  };
  const drilldownEvents = (e) => {
    const { point, target, seriesOptions } = e;
    if (!seriesOptions) {
      const dataToDrill = shouldFetch ? data[chartState] : seriesData;
      for (let key in dataToDrill) {
        if (
          dataToDrill[key] &&
          key.includes("drilldown") &&
          dataToDrill[key].hasOwnProperty(point.drilldown)
        ) {
          const seriesToDrill = dataToDrill[key][point.drilldown];
          if (
            seriesToDrill["name"] === point.series.name &&
            [undefined, null, "pie", ""].includes(seriesToDrill.type)
          ) {
            setInnerSize(seriesToDrill);
            target.addSeriesAsDrilldown(point, seriesToDrill);
          }
        }
      }
      target.applyDrilldown();
    }
  };

  Object.defineProperties(propertiesForChart, {
    events: {
      value: {
        ...events,
        drilldown: drilldownEvents,
      },
      writable: false,
      configurable: false,
      enumerable: true,
    },
    type: {
      value: "pie",
      writable: false,
      configurable: true,
    },
    renderTo: {
      value: undefined,
      writable: false,
      configurable: false,
    },
    custom: { value: {}, writable: false, configurable: false },
  });
  const handleApiResponse = () => {
    let chartSeries=[];
    const chartData = data[chartState];
    const chartError = error[chartState];
    if (chartData && !chartError && isDonut) {
      chartSeries = chartData[seriesKey].map((series) => {
        return { ...series, innerSize: donutInnerSize };
      });
    } else if (chartData && !chartError && !isDonut) {
      chartSeries = chartData[seriesKey];
    }
    if (chartError) {
      return;
    }
    setOptions({
      ...otherOptions,
      chart: { ...propertiesForChart },
      drilldown: {
        series: [],
      }, series: chartSeries
    })
  };
  useEffect(() => {
    handleApiResponse();
  }, [data[chartState], error[chartState], isDonut, donutInnerSize]);
  return (
    <>
      {awaitingResponse[chartState] && <Loader />}
      {error[chartState] && <Alert variant="danger" className="mt-16">
        <p style={{ color: 'red', margin: 0 }}><span className="icon error-alert me-2"></span>{error[chartState]}</p>
      </Alert>}
      {!awaitingResponse[chartState] && data[chartState]?.[seriesKey] && data[chartState]?.[seriesKey]?.length > 0 && options && <HighchartsReact
        highcharts={Highcharts}
        options={options}
        ref={chartRef}
      />}
      {!awaitingResponse[chartState] && !error[chartState] && (!data[chartState]?.[seriesKey] || data[chartState]?.[seriesKey]?.length === 0) && <div className="chart-nodata"><span><NoData /></span></div>}
      {totalValue && shouldFetch && !awaitingResponse[chartState] && data[stateKeys.chart] && <div>
        <p className="piechart-totalbal"><span>{totalValue.title}</span> = <span>{numberFormat(data[stateKeys.chart]?.[totalValue.key], totalValue.decimals || 4, '.', ',')} {totalValue.suffix || ''}</span></p>
      </div>}
    </>
  );
}


export default React.memo(PieOrDonutChart);
